module.exports = __webpack_public_path__ + "media/images/select2-spinner-7b9776076d5fceef4993b55c9383dedd.gif";